/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 137
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';

/**
 * 
 * @export
 * @interface ShapesListGet200Response
 */
export interface ShapesListGet200Response {
    /**
     * 
     * @type {Array<GeoJson>}
     * @memberof ShapesListGet200Response
     */
    records?: Array<GeoJson>;
}

/**
 * Check if a given object implements the ShapesListGet200Response interface.
 */
export function instanceOfShapesListGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShapesListGet200ResponseFromJSON(json: any): ShapesListGet200Response {
    return ShapesListGet200ResponseFromJSONTyped(json, false);
}

export function ShapesListGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShapesListGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(GeoJsonFromJSON)),
    };
}

export function ShapesListGet200ResponseToJSON(value?: ShapesListGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(GeoJsonToJSON)),
    };
}

